// extracted by mini-css-extract-plugin
export default {"auth-page":"auth_auth-page__t86CD","auth-form":"auth_auth-form__Cu4cO"};